import { createContext, PropsWithChildren, ReactNode, useContext, useState } from 'react';
import { iTreeItem } from './types';

interface Context {
  items: Array<iTreeItem>,
  updateParent: (id: number, parent_id: number) => void,
}

const DEFAULTCONTEXT: Context = {
  items: [],
  updateParent: (_id: number, _parent_id: number) => { },
};

const TreeContext = createContext<Context>(DEFAULTCONTEXT)

export const useTreeContext = () => useContext(TreeContext);

interface TreeProviderProps extends PropsWithChildren {
  items: Array<iTreeItem>,
}

const TreeProvider = ({ children, items, }: TreeProviderProps) => {
  const [value, setValue] = useState({
    items,
    updateParent: (id: number, parent_id: number) => {
      setValue(o => {
        let n = [...o.items];
        let itemId = n.findIndex(i => i.id === id);
        if (itemId) {
          n[itemId].parent_id = parent_id;
          return n;
        } else {
          return o;
        }
      })
    }
  });
  return (
    <TreeContext.Provider value={value}>
      {children}
    </TreeContext.Provider>
  )
}

export default TreeProvider;
